export default "/events/@year";
